<template>
  <div>
    <header-component>
      <header-logo />
    </header-component>
    <div
      class="content padding-t"
      :class="{'padding-t-l': balanceNotification}"
    >
      <slot />
    </div>
    <nav-menu />
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import NavMenu from '@/components/NavMenu.vue';
import {mapState} from 'pinia';
import {useModalStore} from '@/stores/modal.js';
import HeaderLogo from '@/components/HeaderLogo.vue';

export default {
  name: 'HomeLayout',
  components: {HeaderLogo, NavMenu, HeaderComponent},
  computed: {
    ...mapState(useModalStore, ['balanceNotification']),
  },
};
</script>
